import React from 'react'
import { useTranslation } from 'react-i18next'
import {List} from 'antd'
import {Card, DateTimeLabel, Description} from '@/components'
import { MobileListProps } from '@/pages/OnlinePayments/components/MobileOnlinePaymentList/props'
import {TJob} from '@/pages/Exports/models/TJob'
export const MobileExportsList: React.FC<MobileListProps<TJob>> = ({dataSource, listExtra, isLoading}) => {
    const { t } = useTranslation()
    return (
        <List
            loading={isLoading}
            dataSource={dataSource}
            itemLayout={'horizontal'}
            renderItem={(item) => (
                <Card
                    key={item.rowId}
                    title={item.fileName}
                    extra={listExtra(item)}
                >
                    <Description dataSource={[
                        {
                            label: t('Exports.status'),
                            value: item.status,
                            key: item.status
                        },
                        {
                            label: t('Exports.dateRequested'),
                            value: item.createdDate,
                            key: item.createdDate,
                            render: () => <DateTimeLabel date={item.createdDate}/>
                        },
                        {
                            label: t('Exports.lastUpdatedDate'),
                            value: item.lastUpdateDate,
                            key: item.lastUpdateDate,
                            render: () => <DateTimeLabel date={item.lastUpdateDate}/>
                        }
                    ]} />
                </Card>
            )}
        />
    )
}
